import React, { Component } from "react";
import { List } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { tabulateImmutable } from "MODULES/shared/decorators";
import { managedRepairOrderActions } from "MODULES/parts/actions";
import { shortDate } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { getConditionAbbrev } from "MODULES/RepairOrders/constants";
import { CompanyName, LocationFlag } from "MODULES/shared/components";
import { CODE, COST, ID, MARKUP, QUANTITY, UUID } from "APP_ROOT/constants";
import {
  CONDITION,
  INVENTORY,
  LEAD_TIME,
  SERIAL_NUMBER,
  STORE_LOCATION_ID
} from "MODULES/inventories/constants";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import { MANAGED_REPAIR_ORDER } from "MODULES/ManagedRepairOrders/constants";
import { BUYER, CO_BUYER, FULL_NAME } from "MODULES/users/constants";
import { percent } from "LIB/formatters/number";

function renderRow(lineItem, i, pushHistory) {
  return (
    <tr
      key={lineItem.get(ID)}
      className="clickable"
      onClick={() =>
        pushHistory(
          `/managed-repair-orders/${lineItem.getIn([
            MANAGED_REPAIR_ORDER,
            UUID
          ])}`
        )}
    >
      <td>{i + 1}</td>
      <td>{lineItem.getIn([MANAGED_REPAIR_ORDER, CODE])}</td>
      <td>{shortDate(lineItem.get("created_at"))}</td>
      <td>
        <CompanyName
          flattenedCompany={lineItem.toJS()}
          context="repair"
          truncateAt={25}
        />
      </td>
      <td>{lineItem.get("contact_name")}</td>
      <td>{lineItem.getIn([BUYER, FULL_NAME])}</td>
      <td>{lineItem.getIn([CO_BUYER, FULL_NAME])}</td>
      <td className="text-center">{lineItem.get(LEAD_TIME)}</td>
      <td>{lineItem.get(SERIAL_NUMBER)}</td>
      <td>{getConditionAbbrev(lineItem.getIn([INVENTORY, CONDITION]))}</td>
      <MultiLocationFeature>
        <td className="text-center">
          <LocationFlag
            location={lineItem.get(STORE_LOCATION_ID)}
            unknownFlag={false}
          />
        </td>
      </MultiLocationFeature>
      <td>{lineItem.get(QUANTITY)}</td>
      <td className="text-right">{dollars(lineItem.get(COST))}</td>
      <td className="text-right">
        {percent(parseFloat(lineItem.get(MARKUP)), 100)}
      </td>
      <td className="text-right">{dollars(lineItem.get("price"))}</td>
    </tr>
  );
}

export class Table extends Component {
  static propTypes = {
    pushHistory: PropTypes.func.isRequired,
    setPageSize: PropTypes.func.isRequired,
    results: PropTypes.instanceOf(List).isRequired
  };

  componentWillMount() {
    this.props.setPageSize(25);
  }

  render() {
    const { pushHistory, results } = this.props;

    return (
      <table className="table table-striped table-hover table-numbered">
        <thead>
          <tr>
            <th />
            <th>MR #</th>
            <th>Date Created</th>
            <th>Customer</th>
            <th>Contact</th>
            <th>Buyer</th>
            <th>Co Buyer</th>
            <th className="text-center">Lead Time (Days)</th>
            <th>Serial #</th>
            <th>CD</th>
            <MultiLocationFeature>
              <th className="text-center">Store Location</th>
            </MultiLocationFeature>
            <th>Qty</th>
            <th className="text-right">Cost</th>
            <th className="text-right">Markup</th>
            <th className="text-right">Price</th>
          </tr>
        </thead>
        <tbody>{results.map((r, i) => renderRow(r, i, pushHistory))}</tbody>
      </table>
    );
  }
}

export default connect(
  () => ({
    listId: "part/managedRepairOrderLineItems"
  }),
  {
    pushHistory: push,
    setPageSize: managedRepairOrderActions.pageActions.setPageSize
  }
)(tabulateImmutable(Table));



// WEBPACK FOOTER //
// ./app/modules/parts/components/ManagedRepairOrderLineItems/Table.jsx